<template>
  <div class="login_form_wrapper">
    <!-- Start:: Form Title -->
    <!-- <div class="form_title_wrapper">
    </div> -->
    <!-- End:: Form Title -->

    <!-- Start:: Form -->
    <div class="form_wrapper">
      <form
        class="mt-4"
        @submit.prevent="validateFormInputs"
        autocomplete="off"
      >
        <div class="row justify-content-center">
          <!-- Start:: Login Type Toggle -->
          <div class="col-lg-7 mb-3">
            <div class="d-flex gap-2 align-baseline">
              <base-button
                @fireClick="loginType = 'email'"
                :styleType="
                  loginType === 'email' ? 'primary_btn' : 'outline_btn'
                "
                :btnText="$t('BUTTONS.email')"
                type="button"
                class="flex-fill"
              />
              <base-button
                @fireClick="loginType = 'phone'"
                :styleType="
                  loginType === 'phone' ? 'primary_btn' : 'outline_btn'
                "
                :btnText="$t('BUTTONS.phone')"
                type="button"
                class="flex-fill"
              />
            </div>
          </div>
          <!-- End:: Login Type Toggle -->

          <!-- Start:: Email Input -->
          <base-input
            v-if="loginType === 'email'"
            col="7"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="loginData.email"
            required
          />
          <!-- End:: Email Input -->

          <!-- Start:: Phone Input -->
          <base-phone-input
            v-if="loginType === 'phone'"
            col="7"
            v-model="loginData.mobile"
            :placeholder="$t('PLACEHOLDERS.phone')"
            @dialCode="loginData.country_code = '+' + $event"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Password Input -->
          <base-input
            col="7"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="loginData.password"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Forget Password Route -->
          <div class="col-lg-7">
            <router-link to="/reset-password-email" class="forget_pass_route">
              {{ $t("BUTTONS.forgetPassword") }}
            </router-link>
          </div>
          <!-- End:: Forget Password Route -->

          <!-- Start:: Submit Button -->
          <div class="col-lg-7 my-5">
            <base-button
              class="mt-0 w-100"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.login')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button -->
        </div>
      </form>
    </div>
    <!-- End:: Form -->
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/messaging";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LoginForm",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loader Data
      isWaitingRequest: false,
      // End:: Loader Data

      // Start:: Login Type (email or phone)
      loginType: "email", // Default to email
      // End:: Login Type

      // Start:: Data Collection To Send
      loginData: {
        email: null,
        mobile: null,
        country_code: "+966",
        password: null,
      },

      device_token: null,
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Vuex Set Authenticated User Data
    ...mapActions({
      setAuthenticatedUserData: "AuthenticationModule/setAuthenticatedUserData",
      updatePermissions: "CaslModule/updatePermissions",
    }),
    // End:: Vuex Set Authenticated User Data

    // Start:: Validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (this.loginType === "email") {
        if (!this.loginData.email) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.email"));
          return;
        }
      } else if (this.loginType === "phone") {
        if (!this.loginData.mobile) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.mobile"));
          return;
        }
        // Validate phone number (8-15 digits)
        const phoneRegex = /^\d{8,15}$/;
        if (!phoneRegex.test(this.loginData.mobile)) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.invalidMobile"));
          return;
        }
      }

      if (!this.loginData.password) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.password"));
        return;
      } else if (this.loginData.password.length < 8) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      } else {
        this.submitForm();
      }
    },
    // End:: Validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data based on login type
      if (this.loginType === "email") {
        REQUEST_DATA.append("email", this.loginData.email);
      } else if (this.loginType === "phone") {
        REQUEST_DATA.append("country_code", this.loginData.country_code);
        REQUEST_DATA.append("mobile", this.loginData.mobile);
      }

      REQUEST_DATA.append("password", this.loginData.password);
      // End:: Append Request Data

      try {
        await fetch("sanctum/csrf-cookie");

        let res = await this.$axios({
          method: "POST",
          url: `auth/login`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));

        // Store data for verification and final login
        localStorage.setItem(
          "perfermo_provider_dashboard_verification_code",
          res.data.data.code
        );
        localStorage.setItem(
          "perfermo_provider_dashboard_login_token",
          res.data.data.access_token
        );

        // Store login data for later use
        const loginDataToStore = {
          password: this.loginData.password,
          fcm_token: this.device_token || "fcm_token",
        };

        if (this.loginType === "email") {
          loginDataToStore.email = this.loginData.email;
          this.setAuthenticatedUserData({
            email: this.loginData.email,
            avatar: res.data.data.image
          });
        } else {
          loginDataToStore.mobile = this.loginData.mobile;
          loginDataToStore.country_code = this.loginData.country_code;
          this.setAuthenticatedUserData({
            mobile: this.loginData.mobile,
            country_code: this.loginData.country_code,
            avatar: res.data.data.image
          });
        }

        localStorage.setItem(
          "perfermo_provider_dashboard_login_data",
          JSON.stringify(loginDataToStore)
        );


        this.clearFormInputs();
        this.$router.replace("/email-verification/login");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Clear Form Inputs
    clearFormInputs() {
      this.loginData.email = null;
      this.loginData.mobile = null;
      this.loginData.country_code = "+966";
      this.loginData.password = null;
    },
    // End:: Clear Form Inputs

    // get fcm token

    async getFirebaseToken() {
      const messaging = firebase.messaging();
      try {
        const token = await messaging.getToken(); // Get the FCM token
        this.device_token = token;
        console.log("FCM token:", token);
      } catch (error) {
        console.error("Error requesting permission/token:", error);
      }
    },
  },

  mounted() {
    this.getFirebaseToken();
  },
};
</script>
